<template lang="pug">
  .product-invoice
    y-dialog(fill-height fluid v-model="showModal" transition="fade-transition" persistent :max-width="step === 0? '400px': '600px'" scrollable)
      v-card
        v-card-title.px-4
          .h6.textColor--text {{ windowTitle }}
        v-divider.basic300(v-if="step > 0 && step < 4")

        v-card-text.px-4(:style="step === 4? 'max-height:340px' : ''")
          v-window(v-model="step")

            v-window-item(:value="0")
              v-container.px-0
                .p1.primary500--text To help you get started with our WhatsApp commerce platform, we’ll walk you through creating your first donation link.
            v-window-item(:value="1")
              v-form.mt-3(ref="form")
                .p1.primary500--text This is where you set your Donation Goal

                .goal
                  
                  v-text-field.mt-2(v-model='donationGoal' :placeholder="0" outlined dense type="number" :rules="rules.has_quantity" :prefix="$currency.symbol" background-color="basic200")
            
            v-window-item(:value="2")
              v-form.mt-3(ref="form")
                .p1.primary500--text This donation product will be used in your first Donation form. Worry not, you can edit or delete this product later.

                .product-name.mt-6
                  .label.basic600--text.text-uppercase {{ $t('product_name.label') }}
                  v-text-field.mt-2(v-model='product.name' :placeholder="$t('product_name.placeholder')" outlined dense persistent-hint :rules="rules.not_empty" counter :maxlength="50" background-color="basic200")

                .price
                  .label.basic600--text.text-uppercase {{ $t('price.label') }}
                  v-text-field.mt-2(v-model='product.price' :placeholder="$t('price.placeholder')" outlined dense type="number" :rules="rules.has_quantity" :prefix="$currency.symbol" background-color="basic200")

            v-window-item(:value="3")
              v-container.pb-0
                .p1.primary500--text Select how you would like to receive money from Donors.
                .methods.mt-n4
                  v-radio-group(v-model='payment.online' mandatory)
                    v-radio(:value="true")
                      template(v-slot:label)
                        v-col
                          .s1.basic800--text Online payment gateway
                          .c1.basic600--text 1 minute setup and start accepting online payment through payment gateways.
                    v-radio(:value="false" hide-details dense)
                      template(v-slot:label)
                        v-col
                          .s1.basic800--text Manual bank transfer
                          .c1.basic600--text Share your bank account number so that customers can pay directly to your bank account.
                .c1.primary400--text *You can change or turn off these payment methods later in Settings.



            v-window-item(:value="4")
              v-container.px-0
                .p1.primary500--text You are now ready to view your first link.
                v-card.mt-8(flat outlined)
                  div.mt-n1
                    v-layout
                      v-layout.mt-1(style="height:56px; max-width:56px; min-width:56px;")
                        eva-icon.ma-auto(name="clipboard-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
                      v-col.pa-0.my-auto
                        v-layout.py-4
                          div.my-auto.pr-2
                            .s1.basic800--text Donation form
                      v-col.pa-0.shrink
                        v-layout.fill-height
                          v-btn.my-auto(color="white" text @click="clickEditForm('/admin/forms')" depressed height=24 small) 
                            .button-Aa-tiny.primary400--text Edit
                          v-btn.my-auto.mr-3(color="info500" dark @click="viewForm()" depressed height=24 small) 
                            .button-AA-tiny.basic100--text View

                v-row
                  v-col.px-0(cols="12")
                    v-card.pa-4(flat)
                      .s1.textColor--text Other useful guides to help you get started:
                      div.mt-2

                        .s2.primary400--text.mt-1 1. Adding product and product variant: 
                        a.c1.textColorAccent--text(href="https://guide.yezza.io/eng/stock-inventory-management/" target="_blank" style="text-decoration: none")
                          div(style="line-height: 1.2em;") https://guide.yezza.io/eng/stock-inventory-management/

                        .s2.primary400--text.mt-3 2. Custom domain request: 
                        a.c1.textColorAccent--text(href="http://guide.yezza.io/eng/steps-to-apply-custom-domain-updated-21-10/" target="_blank" style="text-decoration: none;") 
                          div(style="line-height: 1.2em;") http://guide.yezza.io/eng/steps-to-apply-custom-domain-updated-21-10/
                        
                        .s2.primary400--text.mt-3 3. Setting up your first WhatsApp Form: 
                        a.c1.textColorAccent--text(href="http://guide.yezza.io/eng/making-whatsapp-form/" target="_blank" style="text-decoration: none;") 
                          div(style="line-height: 1.2em;") http://guide.yezza.io/eng/making-whatsapp-form/
                        
                        .s2.primary400--text.mt-3 4. Basic Yezza Store Setup: 
                        a.c1.textColorAccent--text(href="http://guide.yezza.io/eng/setup-yezza-store-2/" target="_blank" style="text-decoration: none;") 
                          div(style="line-height: 1.2em;") http://guide.yezza.io/eng/setup-yezza-store-2/
                        
                        .s2.primary400--text.mt-3 5. Advanced Yezza Store Setup: 
                        a.c1.textColorAccent--text(href="http://guide.yezza.io/eng/how-to-give-a-facelift-to-yezza-store-new/" target="_blank" style="text-decoration: none;") 
                          div(style="line-height: 1.2em;") http://guide.yezza.io/eng/how-to-give-a-facelift-to-yezza-store-new/

        v-card-actions
          v-spacer
          v-btn(v-if="step === 4" @click="finishStep()" color="info500" dark depressed height=32) 
            div.basic100--text Finish
          template(v-else)
            v-btn(v-if="step < 4 " color="white" text @click="skip()" depressed height=32) 
              .button-Aa-small.primary400--text Skip walkthrough
            v-btn(color="info500" dark @click="nextStep()" depressed height=32 :loading="isLoading") 
              .button-AA-small.basic100--text(v-if="step == 0") Get Started
              .button-Aa-small.basic100--text(v-else) Next

    .modals
      update-yezza-pay(v-if="showActivateYZpayDialog" :open.sync="showActivateYZpayDialog" :company="company" @activated="handleActivateGateway")
      update-cash-payment(v-if="showUpdateCashDialog" :open.sync="showUpdateCashDialog" :company="company" @added="handleActivateGateway")
      update-delivery-zone(v-if="showAddZoneDialog" :open.sync="showAddZoneDialog" :company="company" :allowDelete="false" @added="nextStep()")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import UpdateYezzaPay from '@/components/dialogs/settings/UpdateYezzaPay.vue'
import UpdateCashPayment from '@/components/dialogs/settings/UpdateCashPayment.vue'
import UpdateDeliveryZone from '@/components/dialogs/settings/UpdateDeliveryZone.vue'
export default {
  name: 'WalkThroughSetupDialog',
  props: ['open'],
  components: { UpdateYezzaPay, UpdateCashPayment, UpdateDeliveryZone },
  data: () => ({
    step: 0,
    steps: [
      { title: 'Welcome to Yezza'},
      { title: 'Set your Donation goal'},
      { title: 'Create Your First Product'},
      { title: 'Payment methods'},
      { title: 'Congratulations!'}
    ],
    product: {
      name: null,
      price: null
    },
    donationGoal:0,
    payment: {
      online: true
    },
    showActivateYZpayDialog: false,
    showUpdateCashDialog: false,
    showAddZoneDialog: false,
    form: null,
    storeIsReady: false,
    isLoading: false,
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required'],
      has_quantity: [(v) => !!v || 'This field is required', (v) => v != 0|| 'This field is required']
    }
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    authMember () {
      return this.$store.state.user.member
    },
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    windowTitle () {
      return this.steps[this.step].title
    },
    currentProgress () {
      return Math.ceil((this.step / this.steps.length) * 100)
    }
  },
  created () {
    if (this.$store.state.user.walkThrough) {
      const savedWalkThrough = this.$store.state.user.walkThrough
      this.step = savedWalkThrough.step
      if (savedWalkThrough.form) {
        this.form = savedWalkThrough.form
      }
    }
  },
  mounted () {
    this.createYezzaStore()
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    nextStep () {
      if (this.step === 2) {
        this.createProduct()
      } else if (this.step === 3) {
        if (this.payment.online) {
          this.showActivateYZpayDialog = true
        } else {
          this.showUpdateCashDialog = true
        }
      } else {
        this.step++
      }
      if (this.step === 4 && !this.storeIsReady) {
        this.createYezzaStore()
      }
    },
    handleActivateGateway () {
      this.step++
      if (this.payment.online) {
        this.axios.patch(`/companies/${this.company.id}/`, { default_payment_gateway: 'yezzapay' })
      }
    },
    viewYezzaStore () {
      window.open(`https://${this.company.slug}.${process.env.VUE_APP_STORE_URL_DOMAIN}/`, '_blank')
    },
    viewForm () {
      window.open(`https://${this.company.slug}.${process.env.VUE_APP_SHORT_URL_DOMAIN}/${this.form.slug}/`, '_blank')
    },
    clickEditForm (path) {
      this.$store.commit('user/setWalkThrough', { step: 0, skipped: true, skippedTs: new Date() })
      this.showModal = false
      this.$router.push(path)
    },
    skip () {
      this.$store.commit('user/setWalkThrough', { step: 0, skipped: true, skippedTs: new Date() })
      this.showModal = false
      // location.href = '/admin/dashboard'
    },
    finishStep () {
      this.showModal = false
      this.$store.commit('user/setWalkThrough', null)
      location.href = '/admin/dashboard'
    },
    createProduct() {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      let params = {
        company : this.company.id,
        name : this.product.name,
        description : `First product of ${this.company.name}`,
        members: [this.authMember.id],
        categories: [],
        price : (parseFloat(this.product.price)).toFixed(this.$currency.exponent).replace('.', '')
      }
      this.$axios.post(`/products/`, params)
      .then((resp) => {
        this.createForm(resp.data)
      })
      .catch(() => {})
      .catch(() => {
        this.isLoading = false
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      })
    },
    createForm(product) {
      let params = {
        company : this.company.id,
        status: 'published',
        name : 'sample donation form',
        email_enabled : false,
        email_required : false,
        layout : 'list',
         extra_fields: [{
        name: 'donation_target',
        type: 'meta',
        required: false,
        enabled: false,
        send: false,
        target_amount: this.donationGoal*this.$currency.multiplier
         }],
        type: 'donation',
        members: [this.authMember.id],
        products: [product.id]
      }
      this.$axios.post(`/forms/`, params)
      .then((response) => {
        this.step++
        this.form = response.data
        this.$store.commit('user/setWalkThrough', { step: this.step, form: this.form })
      })
      .catch(() => {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      })
      .finally(() => {
        this.isLoading = false
      })
    },
    createYezzaStore() {
      this.$axios.get(`/store/settings/${this.company.slug}/?expand=form`)
        .then(() => {
          this.storeIsReady = true
        })
        .catch(() => {
          let params = {
            company : this.company.id,
            name : `${this.company.slug} - store`,
            email_enabled : false,
            email_required : false,
            layout : 'inquiry',
            extra_fields : [],
            type: 'store'
          }
          this.$axios.post(`/forms/`, params)
          .then((response) => {
            params = {
              company : this.company.id,
              name: '',
              form: response.data.id
            }
            this.$axios.post(`/store/settings/`, params)
              .then(() => {
                this.storeIsReady = true
              }).catch(() => {})
          }).catch(() => {})
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "product_name": {
      "label": "Product name",
      "placeholder": "Write product name here"
    },
    "price": {
      "label": "Price",
      "placeholder": "0"
    }
  }
}
</i18n>
